/**
 * The Saudi riyal sign (U+20C1), used for every on-screen amount in both
 * languages. Fonts don't ship the glyph yet, so `public/fonts/saudi-riyal.woff2`
 * (built by tools/fonts/build-riyal-font.py from SAMA's outline) is first in
 * every font stack with `unicode-range: U+20C1`, which makes this plain
 * character render anywhere in the DOM.
 *
 * Text that leaves the browser (SMS, WhatsApp, email, Excel/CSV exports, jsPDF)
 * can't rely on that font: keep the words "ر.س" / "SAR" there.
 */
export const RIYAL = "⃁";
